module.exports = __webpack_public_path__ + "img/hos2.9469ab4e.png";